/* ====================================================================
   Lunai favorites — client-side wishlist (localStorage 'lunai-wishlist').
   - Hearts: any [data-fav-toggle] with [data-fav-handle] toggles + shows
     an .is-on state.
   - Header badge: any [data-fav-count] shows the saved count.
   - Favorites page: a [data-fav-grid] container is filled from
     /products/{handle}.js, with [data-fav-empty] shown when empty.
   ==================================================================== */
(function () {
  var KEY = 'lunai-wishlist';
  /* Handle→variant map: WHICH colourway the shopper hearted, so the
     favourites surfaces can show the pink bottle they saved instead of
     the green featured photo. Kept OUTSIDE the handle array on purpose —
     every other reader of 'lunai-wishlist' (the collection chips fav
     filter, the pre-paint gates in lunai-mojlunai-favs and
     main-list-collections) keeps parsing a plain array of handles. A
     handle with no entry is a favourite from before the map, or one
     hearted on a surface with no variant context (collection card) —
     both render in the product's default context, exactly as before. */
  var VKEY = 'lunai-wishlist-v';
  /* Shared with lunai-search.js on purpose: both surfaces render the same
     compact card from the same section, so one warmed cache serves both —
     which is also why the locale has to be IN the key. The cached value is
     rendered markup: a shopper who switches to DE would otherwise be
     served the Slovenian card for the rest of the session. The per-card
     key is FAVCACHE + handle + (':' + variantId when one is stored) —
     variant in the key, or re-hearting another colour would serve the old
     colour's cached card. Keep the expressions identical in both files or
     the two surfaces stop sharing. */
  var FAVCACHE = 'lunai-favcard-' + ((window.Shopify && window.Shopify.locale) || '') + '-';
  /* One in-flight compact-card fetch per handle, shared across rails: since
     the #mojLunai panel a page can carry two rails whose handle sets
     overlap, and the sessionStorage cache only covers SETTLED responses. */
  var INFLIGHT = {};
  var RAIL_LIMIT = 12;
  var LS = window.lunaiStrings || {};
  function read() { try { return JSON.parse(localStorage.getItem(KEY) || '[]') || []; } catch (e) { return []; } }
  function write(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
  function readV() { try { return JSON.parse(localStorage.getItem(VKEY) || '{}') || {}; } catch (e) { return {}; } }
  function writeV(m) { try { localStorage.setItem(VKEY, JSON.stringify(m)); } catch (e) {} }
  function variantOf(h) { return readV()[h] || ''; }
  function has(h) { return read().indexOf(h) >= 0; }
  function toggle(h, vid) {
    if (!h) return false;
    var a = read(), i = a.indexOf(h), m = readV();
    if (i >= 0) { a.splice(i, 1); delete m[h]; } else { a.push(h); if (vid) m[h] = String(vid); }
    write(a);
    writeV(m);
    document.dispatchEvent(new CustomEvent('lunai:fav'));
    return i < 0;
  }
  /* A render just proved this handle no longer resolves to a published
     product — drop it from storage so the badges agree with what the
     shopper can actually see. Calls syncStates() directly instead of
     dispatching 'lunai:fav': the event listener re-runs renderGrid,
     which would restart every in-flight fetch mid-render. */
  function prune(h) {
    var a = read(), i = a.indexOf(h);
    if (i < 0) return;
    a.splice(i, 1);
    write(a);
    var m = readV();
    if (m[h]) { delete m[h]; writeV(m); }
    syncStates();
  }
  /* The colourway a heart records. [data-fav-live] (the PDP heart) reads
     the CURRENT picker selection at tap time — Dawn's selected-variant
     JSON first, the product form's id input as the fallback (a
     single-variant product renders no picker, and a combination with no
     variant serialises as null). Everywhere else the server-stamped
     data-fav-variant attribute speaks (fav cards re-rendered in variant
     context carry theirs, so un-heart → re-heart keeps the colour); no
     attribute means no variant context — store the product alone. */
  function variantFor(b) {
    if (b.hasAttribute('data-fav-live')) {
      var sec = b.closest('.shopify-section') || document;
      var el = sec.querySelector('variant-selects [data-selected-variant]');
      if (el) {
        try {
          var v = JSON.parse(el.textContent);
          if (v && v.id) return String(v.id);
        } catch (e) {}
      }
      var inp = sec.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (inp && inp.value) return String(inp.value);
    }
    return b.getAttribute('data-fav-variant') || '';
  }
  function syncStates() {
    document.querySelectorAll('[data-fav-toggle]').forEach(function (b) {
      var on = has(b.getAttribute('data-fav-handle'));
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var n = read().length;
    document.querySelectorAll('[data-fav-count]').forEach(function (el) {
      el.textContent = n;
      /* badges disappear at 0; stat tiles opt out via data-fav-count-always
         (a blank number tile reads as broken, an absent badge as quiet) */
      el.hidden = n === 0 && !el.hasAttribute('data-fav-count-always');
    });
  }
  /* B7 audit fix: hearts are DELEGATED at document level so they keep
     working on cards injected later (facet AJAX innerHTML swaps, the
     Section-Rendering wishlist grid, search results) — the old
     per-element bindings died after the first facet interaction.
     syncStates() re-runs on grid mutations below. */
  var togglesWired = false;
  function wireToggles() {
    if (togglesWired) return;
    togglesWired = true;
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-fav-toggle]');
      if (!b) return;
      e.preventDefault();
      e.stopPropagation();
      var added = toggle(b.getAttribute('data-fav-handle'), variantFor(b));
      if (added) { pulseFav(); pulse(b); }
    });
    var container = document.getElementById('ProductGridContainer');
    if (container && 'MutationObserver' in window) {
      new MutationObserver(function () {
        syncStates();
        /* facet/sort AJAX replaces the grid markup — repaint the
           colour dots (server markup only carries the beige fallback) */
        if (window.lunaiDecorateCards) window.lunaiDecorateCards(container);
      }).observe(container, { childList: true, subtree: true });
    }
  }
  function pulse(el) {
    if (!el) return;
    el.classList.remove('is-pulse');
    void el.offsetWidth;            /* restart animation */
    el.classList.add('is-pulse');
    setTimeout(function () { el.classList.remove('is-pulse'); }, 650);
  }
  function pulseFav() {
    document.querySelectorAll('[data-fav-count]').forEach(pulse);
  }
  /* R2.4: the wishlist shows REAL lunai-product-card markup, fetched per
     handle through the Section Rendering API (lunai-fav-card section
     rendered in each product's own context). One card system, one money
     format, bag/quick-add included. Order preserved via placeholders. */
  function renderGrid(grid) {
    var handles = read();
    var empty = document.querySelector('[data-fav-empty]');
    grid.innerHTML = '';
    if (!handles.length) { if (empty) empty.hidden = false; return; }
    if (empty) empty.hidden = true;
    var root = (window.routes && window.routes.root_url && window.routes.root_url !== '/')
      ? window.routes.root_url.replace(/\/$/, '') : '';
    /* Mirror of the rail's all-failed fallback: if every stored handle
       turns out stale the grid would sit blank with the badge at 0 and
       no message, so show the empty state once the last fetch settles. */
    var pending = handles.length;
    function settled() {
      pending--;
      if (pending === 0 && !grid.firstElementChild && empty) empty.hidden = false;
    }
    handles.forEach(function (h) {
      var slot = document.createElement('div');
      slot.className = 'lunai-fav-slot';
      grid.appendChild(slot);
      /* &variant= puts product.selected_variant into the section's Liquid
         context, so the card shows the hearted colourway (image, price,
         link) instead of the featured photo. */
      var vid = variantOf(h);
      fetch(root + '/products/' + encodeURIComponent(h) + '?section_id=lunai-fav-card' + (vid ? '&variant=' + encodeURIComponent(vid) : ''))
        .then(function (r) {
          if (r.ok) return r.text();
          /* 404 = deleted/unpublished/renamed — definitively gone.
             Other statuses (5xx, rate limit) are transient: drop the
             slot for now but keep the favourite. */
          if (r.status === 404) prune(h);
          return null;
        })
        .then(function (html) {
          if (!html) { slot.remove(); return; }
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var payload = doc.querySelector('[data-fav-card-payload]');
          if (!payload || !payload.firstElementChild) { prune(h); slot.remove(); return; }
          while (payload.firstElementChild) slot.appendChild(payload.firstElementChild);
          wireToggles(slot);
          syncStates();
          if (window.lunaiDecorateCards) window.lunaiDecorateCards(slot);
        })
        .catch(function () { slot.remove(); })
        .then(settled);
    });
  }
  /* ── Catalog favourites rail (#M1) ────────────────────────────────
     The catalog page opens with the shopper's own favourites instead of
     a static hint. Same Section-Rendering rule as the wishlist grid, but
     the COMPACT card (sections/lunai-search-fav.liquid) — the full card
     is a quick-add surface and far too tall for a 175px rail.

     Three differences from renderGrid, all deliberate:
     - sessionStorage cache per handle, shared with the search sheet. The
       grid re-fetches every favourite on every heart tap; on a rail that
       sits above the fold of a browsing page that is a request storm.
     - newest first, capped at RAIL_LIMIT — the rail is a shortcut, and
       the "Vse" link goes to the full list.
     - a join-key short-circuit so an unrelated heart elsewhere on the
       page does not rebuild an unchanged rail. */
  function renderRail(rail) {
    /* Per-surface cap: the #mojLunai grid asks for its approved nine via
       data-fav-limit; every other rail keeps the default. */
    var limit = parseInt(rail.getAttribute('data-fav-limit') || '', 10) || RAIL_LIMIT;
    var handles = read().slice().reverse().slice(0, limit);
    var root = rail.closest('[data-fav-rail-root]') || document;
    var emptyCard = root.querySelector('[data-fav-rail-empty]');
    var allLink = root.querySelector('[data-fav-rail-all]');

    function showEmpty() {
      rail.hidden = true;
      rail.innerHTML = '';
      rail._favKey = null;
      if (emptyCard) emptyCard.hidden = false;
      if (allLink) allLink.hidden = true;
    }

    if (!handles.length) { showEmpty(); return; }

    if (emptyCard) emptyCard.hidden = true;
    if (allLink) allLink.hidden = false;
    rail.hidden = false;

    /* Variant in the join key too: re-hearting a favourite in another
       colour keeps the same handle set, and a handle-only key would
       short-circuit the rebuild that shows the new colour. */
    var key = handles.map(function (h) { return h + ':' + variantOf(h); }).join(',');
    if (rail._favKey === key) return;
    rail._favKey = key;
    rail.innerHTML = '';

    var base = (window.routes && window.routes.root_url && window.routes.root_url !== '/')
      ? window.routes.root_url.replace(/\/$/, '') : '';
    /* Every handle that fails drops its slot. If they ALL fail — a wishlist
       of products the merchant has since unpublished — the rail would be a
       blank 175px box with the hint card already hidden, so fall back to
       the hint once the last one has settled. */
    var pending = handles.length;
    function settled() {
      pending--;
      if (pending === 0 && !rail.firstElementChild) showEmpty();
    }

    handles.forEach(function (h) {
      var slot = document.createElement('div');
      slot.className = 'lk-fav__slot';
      slot.setAttribute('role', 'listitem');
      rail.appendChild(slot);          /* placeholder first — fetches settle out of order */

      /* Variant-suffixed cache/in-flight keys, same scheme as
         lunai-search.js — a handle-only key would keep serving the old
         colour's card after the shopper re-hearts another colourway. */
      var vid = variantOf(h);
      var ck = FAVCACHE + h + (vid ? ':' + vid : '');
      var cached = null;
      try { cached = sessionStorage.getItem(ck); } catch (e) {}
      if (cached) { slot.innerHTML = cached; settled(); return; }

      var req = INFLIGHT[ck];
      if (!req) {
        req = INFLIGHT[ck] = fetch(base + '/products/' + encodeURIComponent(h) + '?section_id=lunai-search-fav' + (vid ? '&variant=' + encodeURIComponent(vid) : ''))
          .then(function (r) {
            if (r.ok) return r.text();
            if (r.status === 404) prune(h);   /* gone for good — badge must agree */
            return null;
          });
        req.then(function () { delete INFLIGHT[ck]; }, function () { delete INFLIGHT[ck]; });
      }
      req
        .then(function (html) {
          if (!html) { slot.remove(); return; }
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var payload = doc.querySelector('[data-lsfav-payload]');
          if (!payload || !payload.firstElementChild) { prune(h); slot.remove(); return; }
          slot.innerHTML = payload.innerHTML;
          try { sessionStorage.setItem(ck, payload.innerHTML); } catch (e) {}
        })
        .catch(function () { slot.remove(); /* transient failure — drop the slot, keep the favourite */ })
        .then(settled);
    });
  }

  function init() {
    wireToggles(document);
    syncStates();
    var grid = document.querySelector('[data-fav-grid]');
    if (grid) renderGrid(grid);
    /* Re-queried rather than captured: a Theme Editor section re-render
       replaces the element, and a captured reference would keep painting
       into a node no longer in the document. Since the #mojLunai panel
       (2026-08-20) a page can carry SEVERAL rails — the header panel plus
       a catalog/page rail — so every rail is painted, each against its own
       [data-fav-rail-root]. */
    function paintRails() {
      document.querySelectorAll('[data-fav-rail]:not([data-fav-defer])').forEach(renderRail);
    }
    /* [data-fav-defer]: the #mojLunai dropdown rides in the header of every
       page, and its nine Section-Rendering fetches would fire on every
       load for shoppers who never open the menu. A deferred rail stays
       unpainted until its dropdown is first hovered or focused — painting
       starts during the open animation, and renderRail's _favKey plus the
       sessionStorage card cache keep repeated opens from refetching. */
    function wireDeferredRails() {
      document.querySelectorAll('[data-fav-rail][data-fav-defer]').forEach(function (rail) {
        if (rail._deferWired) return;
        rail._deferWired = true;
        var host = rail.closest('.has-dropdown') || rail;
        var go = function () {
          host.removeEventListener('mouseenter', go);
          host.removeEventListener('focusin', go);
          rail.removeAttribute('data-fav-defer');
          renderRail(rail);
        };
        host.addEventListener('mouseenter', go);
        host.addEventListener('focusin', go);
      });
    }
    paintRails();
    wireDeferredRails();
    /* Narrow repaint for surfaces that just un-deferred a rail (the
       drawer's #mojLunai group, lunai-nav.js): rails only — 'lunai:fav'
       below would also refetch a wishlist-page grid. */
    document.addEventListener('lunai:fav-rails', paintRails);
    document.addEventListener('lunai:fav', function () {
      syncStates();
      if (grid) renderGrid(grid);
      paintRails();
    });
    document.addEventListener('shopify:section:load', function () {
      paintRails();
      wireDeferredRails();
    });
    // Pulse the cart count bubble whenever Dawn re-renders it (item added).
    var cartIcon = document.getElementById('cart-icon-bubble');
    if (cartIcon && 'MutationObserver' in window) {
      new MutationObserver(function () {
        pulse(cartIcon.querySelector('.cart-count-bubble'));
      }).observe(cartIcon, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.LunaiFav = { toggle: toggle, has: has, prune: prune, variantOf: variantOf, count: function () { return read().length; } };
})();
